import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Container, Section, H1, H3, Body1, Loader } from '../../cdl-react-components/components'
import ArticleDisplay from '../../Utilities/ArticleDisplay'
import RegionalMapDisplay from '../../Utilities/RegionalMapDisplay'
import { graphqlFetch, sortPropDescFn } from '../../cdl-react-components/utilities'
import { logEvent } from '../../../utilities'

const ContentGroup = (props) => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const [group, setGroup] = useState()
    const [articleGroups, setArticleGroups] = useState()
    const [regionalMapGroups, setRegionalMapGroups] = useState()

    useEffect(() => {
        fetchContentGroup(id)
    }, [id])

    const fetchContentGroup = () => {
        const groupId = id

        if (!group || group.id !== groupId) {
            logEvent({ 'Content_Group_Viewed': groupId })
            graphqlFetch('wcms3', `
                query {
                    contentGroups (
                        where: { id: { eq: ${groupId} } }
                    ){
                        id
                        name
                        priority
                        description
                        top_play: topPlay {
                            id
                        }
                        articles: contentContentgroupArticles {
                            article {
                                id
                                title
                                subtitle
                                image
                                featured_article: featuredArticle
                                publication_date: publicationDate
                                synopsis
                                article_type: contentArticleArticleTypes {
                                    articletype {
                                        id
                                        name
                                    }
                                }
                                authors: contentArticleAuthors {
                                    author {
                                        id
                                        name
                                    }
                                }
                                ep_type: epType {
                                    id
                                    name
                                }
                            }
                        }
                        regional_maps: contentContentgroupRegionalMaps {
                            regionalmap {
                                id
                                title
                                subtitle
                                image
                                publication_date: publicationDate
                                description
                            }
                        }
                    }
                }`)
                .then(res => {
                    if (res.data.contentGroups.length === 0)
                        navigate('/')
                    else {
                        const group = res.data.contentGroups[0]

                        group.top_play = group.top_play?.id
                        group.regional_maps = group.regional_maps
                            .map(x => x.regionalmap)
                        group.articles = group.articles
                            .map(x => x.article)
                            .map(article => ({
                                ...article,
                                ep_type: article.ep_type?.name,
                                article_type: article.article_type?.map(x => ({ ...x.articletype })),
                                authors: article.authors?.map(x => x.author)
                            }))

                        setGroup(group)
                        setArticleGroups(groupData(group.articles))
                        setRegionalMapGroups(groupData(group.regional_maps))
                        setLoading(false)
                    }
                })            
        }
    }

    const groupData = (data) => {
        const groupedData = []
        let dataGroup = []

        data = data.sort(sortPropDescFn('publication_date'))

        data.forEach(dat => {
            dataGroup.push(dat)

            if (dataGroup.length === 4) {
                groupedData.push(dataGroup)
                dataGroup = []
            }
        })

        if (dataGroup.length > 0)
            groupedData.push(dataGroup)

        return groupedData
    }

    return !loading && group ? (
        <Container className="content-group">
            <Section className="content-group__header">
                <H1>{group.name}</H1>
                { group.description && (<Body1 dangerouslySetInnerHTML={{ __html: group.description }}/>) }
            </Section>
            <Section className="content-group__body">
                { regionalMapGroups && regionalMapGroups.length > 0 && <H3>CDL Map Series</H3> }
                { regionalMapGroups && regionalMapGroups.map((group, i) => (
                    <div 
                        className="content-group__body__group"
                        key={'content-group__body__regional-map-group--' + i}>
                        { group.map((map, i) => <RegionalMapDisplay key={'content-group-regional-map--' + i} map={map}/>) }
                    </div>
                ))}
                { articleGroups && articleGroups.length > 0 && <H3>Articles</H3> }
                { articleGroups && articleGroups.map((group, i) => (
                    <div 
                        className="content-group__body__group"
                        key={'content-group__body__article-group--' + i}>
                        { group.map((article, i) => <ArticleDisplay key={'content-group-article--' + i} article={article}/>) }
                    </div>
                ))}
            </Section>
        </Container>
    ) : <Loader />
}

const mapStateToProps = ({ data }) => ({ contentMode: data.configuration.contentMode })

export default connect(mapStateToProps)(ContentGroup)